(function(window, $) {
    if ($('#locationMap').length > 0) {
        $('.location-map').find('.map__marker').each(function() {
            var image = new Image();
            image.src = $(this).data('image');
        });

        // Initially show first marker
        $('.location-map').find('.map__marker').first().addClass('show-marker');

        $('#locationMap area').on({
            click: function (e) {
                e.preventDefault();
                var identifier = $(this).attr('href');
                $(this).parents('.location-map').eq(0).attr('data-active', identifier);

                var marker = $(this).parents('.location-map').find('.map__marker'+ identifier);
                var image = marker.data('image');
                var imageContainer = $(this).parents('.location-map').find('.location-map__image');

                // Change Image
                imageContainer.css('background-image', 'url(' + image + ')');
                imageContainer.find('img').css('opacity', '0');

                // Show right marker
                $(this).parents('.location-map').find('.map__marker').each(function() {
                    $(this).removeClass('show-marker');
                });
                marker.addClass('show-marker');
            }
        });
    }
})(window, jQuery);